import React, {Component} from 'react'
import ReactDOM, {render} from 'react-dom'
import {connect} from 'react-redux'
import {Transition} from 'semantic-ui-react'

import {setMenuVisible, setPageVisible} from '../actions'

import styles from './Home.module.scss'


class Home extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isPageVisible: false
        }

        this.showContent = this.showContent.bind(this);
        this.hideContent = this.hideContent.bind(this);
        this.toLatestPage = this.toLatestPage.bind(this);
    }

    showContent() {
        this.setState({
            isPageVisible: true
        });
    }

    hideContent() {
        this.setState({
            isPageVisible: false
        });
    }

    componentDidMount() {
        this.showContent();
    }

    componentWillUnmount() {
    }

    toLatestPage() {
        this.props.history.push("/latest");
    }

    render() {
        return (
            <>
                <div className={`${styles.home} ${styles.desktop}`}>
                    <Transition visible={this.state.isPageVisible} animation='fade' duration={1500}
                                onShow={this.hideContent} onHide={this.toLatestPage}>
                        <div className={styles.page_wrapper}>
                            <div className={styles.logo_container}>
                                <img src={process.env.PUBLIC_URL + "/images/menu/ol_Logo_2019ver-w.png"}/>
                            </div>
                        </div>
                    </Transition>
                </div>

                <div className={`${styles.home} ${styles.mobile}`}>
                    <div className={styles.menu_wrapper}>
                        <div className={styles.menu} onClick={() => {
                            this.props.setMenuVisible(true)
                        }}>
                            <span className={styles.menu_icon}><div className={styles.menu_icon_line}></div></span>
                            <span className="vertical_center">OUTLAND Film Production</span>
                        </div>
                    </div>
                    <div className={styles.page_wrapper}>
                        <div className={styles.logo_container}>
                            <img src={process.env.PUBLIC_URL + "/images/menu/ol_Logo_2019ver-w.png"}/>
                        </div>
                    </div>
                </div>
            </>
        )
    }

};

const mapStateToProps = state => {
    return {
        isPageVisible: state.isPageVisible
    };
};

export default connect(mapStateToProps, {setMenuVisible, setPageVisible})(Home);
